import { Box, CircularProgress, Typography } from '@mui/material'

import { CardBox } from '../../../theme/styleComponents'
import { CARD_SUBTITLE_SX } from './constants'

export interface StatItem {
  label: string
  value: string
}

interface StatCardProps {
  title: string
  subtitle?: string
  /** The first item is the headline figure; the rest render smaller beside it. */
  items: StatItem[]
  loading?: boolean
}

/** A titled card of one or more summary figures, e.g. a total and its breakdown. */
const StatCard = ({ title, subtitle, items, loading }: StatCardProps) => {
  const [headline, ...breakdown] = items

  return (
    <CardBox height="100%">
      <Box px={3} py={2} borderBottom="1px solid" borderColor="lightGrayThree">
        <Typography fontSize="18px">{title}</Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={CARD_SUBTITLE_SX}>
            {subtitle}
          </Typography>
        )}
      </Box>

      <Box px={3} py={2.5} minHeight={96} display="flex" alignItems="center">
        {loading ? (
          <CircularProgress size={28} />
        ) : (
          <Box display="flex" flexWrap="wrap" alignItems="flex-end" columnGap={5} rowGap={2}>
            <Box>
              <Typography variant="body2" color="text.secondary">
                {headline.label}
              </Typography>
              <Typography fontSize="32px" fontWeight={600} lineHeight={1.2}>
                {headline.value}
              </Typography>
            </Box>
            {breakdown.map(item => (
              <Box key={item.label}>
                <Typography variant="body2" color="text.secondary">
                  {item.label}
                </Typography>
                <Typography fontSize="22px" fontWeight={500} lineHeight={1.3}>
                  {item.value}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </CardBox>
  )
}

export default StatCard
